import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type PageTypes = 'DB_PAGE' | 'DEAL_VIEW' | 'LOGIN_PAGE';

export const useOnPageLoad = (page: PageTypes, fn: () => void) => {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname == '/' && page == 'DB_PAGE') {
            fn();
        } else if (location.pathname == '/login' && page == 'LOGIN_PAGE') {
            fn();
        } else {
            //DEAL_VIEW
            fn();
        }
    }, [location]);
};
